<template>
  <div class="background" ref="card">
    <a-card class="card">
      <div>
        <!-- ✅ 圆形 logo 容器 + 悬浮效果 -->
        <div class="logo-container">
          <div class="logo-wrapper">
            <img :src="logo" alt="logo" class="logo-img" />
          </div>
        </div>

        <div
          style="text-align: center; font-size: 20px; color: #50799e; margin-top: 8px; margin-bottom: 24px; font-weight: bold;"
        >
          <span>{{ ProjectName }}</span>
        </div>
      </div>

      <router-view />
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'UserLayout',
  data() {
    return {
      logo: require('@/assets/logo.png')
    }
  },
  methods: {}
}
</script>

<style scoped>
.card {
  width: 480px;
  border-radius: 8px;
  padding-bottom: 64px;
  margin: auto;
  color: #50799e;
}

.background {
  min-height: 100%;
  padding: 10vh 0;
  background: url('https://pic2.ziyuan.wang/user/tanfuhua/2024/08/v2-e2d0fa9819c540732a4e7e980d5b48a9_r_26ba0cd0fea17.jpg');
  background-size: 100% 100%;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #50799e;
  margin-top: 8px;
  font-weight: bold;
}

/* ✅ 让外层负责居中和间距 */
.logo-container {
  text-align: center;
  padding-top: 16px;
  margin-top: 16px;
}

/* ✅ 圆形 + 阴影 + 悬浮动画 */
.logo-wrapper {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* ✅ 悬浮时上移 + 放大 + 阴影加深 */
.logo-wrapper:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

/* ✅ 图片铺满圆形区域（裁成圆形） */
.logo-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
